import {QuestionItem} from './questionitem';

export class QuestionSituation extends QuestionItem {

  action: string;

}



// WEBPACK FOOTER //
// ./src/models/questionsituation.ts